import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const DashboardNavContainer = styled.div`
  width: 100%;
  display: block;

  .pin-container {
    display: none;

    @media (min-width: ${breakpoints.desktop}px) {
      display: flex;
      justify-content: flex-end;
      min-width: 56px;

      .pin-nav {
        color: ${colors.white};
        cursor: pointer;
      }
    }
  }

  .mobile-icons {
    display: flex;
    background-color: ${colors.dark7};
    justify-content: space-between;
    padding: 0 2rem;
    color: ${colors.white};

    .mobile-icon-wrapper {
      cursor: pointer;
      padding: 10px 1rem 8px;

      .material-symbols-outlined {
        padding-top: 2px;
      }

      svg,
      .material-symbols-outlined {
        font-size: 42px;
      }

      &.active {
        background-color: ${colors.white};
        border-top: 4px solid ${colors.dark7};
        padding-top: 6px;

        color: ${colors.dark7};
      }
    }

    @media (min-width: ${breakpoints.desktop}px) {
      display: none;
    }
  }

  @media (min-width: ${breakpoints.desktop}px) {
    margin-right: 1rem;
    max-width: 224px;

    &.collapsed {
      width: auto;

      .dashboard-nav {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;

        .navbar-icon {
          margin-top: 0.5rem;
        }

        h3 {
          display: none;
        }

        .navbar-titles {
          display: none;
          align-items: center;
        }
      }
    }
  }
  @media (min-width: ${breakpoints.sm}px) {
    max-width: 250px;
  }
  @media (min-width: ${breakpoints.md}px) {
    max-width: 285px;
  }
  @media (min-width: ${breakpoints.xxl}px) {
  }

  .dashboard-nav {
    height: 100%;
    background-color: ${colors.white};
    border-bottom: 2px solid ${colors.dark7};

    @media (min-width: ${breakpoints.desktop}px) {
      margin: 0 0rem 0.5rem 1rem;
      padding: 1rem;
      border-radius: 15px;
      background-color: ${colors.dark7};
      border-bottom: none;
    }
  }

  .navbar-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    padding: 1rem 2rem;

    .nav-section-top {
      display: flex;
      align-items: end;
      margin-bottom: 3px;
    }

    @media (min-width: ${breakpoints.desktop}px) {
      padding: 0;
    }

    &:not(.active) {
      display: none;
      @media (min-width: ${breakpoints.desktop}px) {
        display: flex;
      }
    }

    .navbar-icon {
      display: none;

      @media (min-width: ${breakpoints.desktop}px) {
        display: block;
        cursor: pointer;
        max-height: 38px;

        svg,
        span {
          font-size: 38px;
          color: ${colors.white};
        }

        .material-symbols-outlined {
          max-height: 50px;
        }
      }
    }

    .navbar-titles {
      margin-left: 0.5rem;
      margin-top: 0.5rem;

      @media (min-width: ${breakpoints.desktop}px) {
        &.hidden {
          display: none;
        }
      }
    }

    a {
      h3,
      h4 {
        @media (min-width: ${breakpoints.desktop}px) {
          color: ${colors.white};
        }
      }

      h3 {
        font-size: 21px;
        line-height: 21px;
        margin: 5px 0.5rem;

        @media (min-width: ${breakpoints.desktop}px) {
          font-size: 19px;
          line-height: 19px;
        }
      }

      h4 {
        font-size: 14px;
        font-weight: normal;
        line-height: 19px;
        margin-left: 12px;

        @media (min-width: ${breakpoints.desktop}px) {
          margin-left: 1rem;
        }
      }

      &.active {
        h3 {
          font-weight: bold;
        }

        h4 {
          font-weight: bold;
          text-decoration: underline;
        }
      }

      &:hover {
        color: ${colors.white};
      }
    }
  }
`
